import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';

import {
  ConnectedOverlayDirective,
  OverlayOriginDirective,
  IconComponent,
  RtTooltip,
  ButtonComponent,
} from '@recruitee/user-interface';

import { InsertPlaceholderInputDirective } from '../insert-placeholder-input.directive';
import { Placeholder } from '../placeholder';
import { PlaceholderSelectDropdownComponent } from '../placeholder-select-dropdown/placeholder-select-dropdown.component';
import { PlaceholderService } from '../placeholder.service';

@Component({
  selector: 'rt-placeholder-category-button',
  templateUrl: './placeholder-category-button.component.html',
  styleUrls: ['./placeholder-category-button.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ButtonComponent,
    OverlayOriginDirective,
    RtTooltip,
    IconComponent,
    ConnectedOverlayDirective,
    PlaceholderSelectDropdownComponent,
  ],
})
export class PlaceholderCategoryButtonComponent {
  @Input() public category: string;
  @Input() public activeTarget: InsertPlaceholderInputDirective | undefined;
  @Input() public placeholders: Placeholder[];
  public placeholderCategoryTranslationMap =
    this.placeholderService.placeholderCategoryTranslationMap;

  @ViewChild('placeholderSelectDropdown')
  public placeholderSelectDropdown: ConnectedOverlayDirective;

  @Output() public select: EventEmitter<Placeholder> = new EventEmitter();

  constructor(private placeholderService: PlaceholderService) {}

  public placeholderSelectDropdownToggle(event: Event) {
    event.stopPropagation();
    event.preventDefault();
    this.placeholderSelectDropdown.open = !this.placeholderSelectDropdown.open;
  }
}
